const state = {
    loginAccount: null,
    loginUsername: null,
    loginStatus: false,
};

const getters = {
    get_loginData: state => {
        var loginData = {};
        loginData.account = state.loginAccount;
        loginData.username = state.loginUsername;
        loginData.status = state.loginStatus;
        return loginData;
    },
};
const actions = {
    change_loginData(context, obj) {
        context.commit("CHANGE_LOGINDATA", obj);
    },
};
const mutations = {
    CHANGE_LOGINDATA(state, obj) {
        state.loginAccount = obj.account;
        state.loginStatus = obj.status;
        state.loginUsername = obj.username;
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
